<template>
  <multiform-list-manager
      :readonly="true"
      :value="households[0].borrowers"
      :itemName="I18NGetter().useSimulationFormStep2And3.BORROWER">
    <template #default="{item}">
      <simulation-form-step3-wrapper :borrower="item" />
    </template>
  </multiform-list-manager>
</template>
<script lang="ts" setup>
import {defineComponent} from 'vue';
import {useHouseholds} from '@/components/calculator/form/useSimulationForm';
import MultiformListManager from '@/modules/multiForm/views/MultiformListManager.vue';
import SimulationFormStep3Wrapper from '@/components/calculator/form/SimulationFormStep3Wrapper.vue';
import {FFBorrower} from '@/models/ExpertState';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
const {households,} = useHouseholds();

</script>
<style scoped lang="scss">
</style>
